import {TranslationObject} from '@colonist/i18n'
import {BaseCardData, CardClickPopupType} from './BaseCardData'
import {CardEnum, CardTypeEnum} from '@colonist/game-states'

export class CardProgressBack extends BaseCardData {
    cardEnum = CardEnum.ProgressCardBack
    cardTypeEnum = CardTypeEnum.ProgressTrade
    isCardBack = true
    imageFileName = 'card_progress_back'
    tipTitle: TranslationObject = {key: 'strings:game.cards.progress.title.ProgressCards'}
    tipBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    clickPopupType = CardClickPopupType.None
    popupBody: TranslationObject = {key: 'strings:colonistCommon.utils.emptyString'}
    allowableTurnStates = undefined
}
